import { parseJSON, format } from 'date-fns';

export const formatDateTime = (dateTimeStr: string) =>  {
    const dateStr = parseJSON(dateTimeStr);
    const newDate = format(new Date(dateStr), 'MM/dd/yyyy');
    const newTime = format(new Date(dateStr), 'hh:mm aaaa');
    return `${newDate} at ${newTime}`;
};

export const formatDateWithAt = (dateTimeStr: string) =>  {
    const dateStr = parseJSON(dateTimeStr);
    const newDate = format(new Date(dateStr), 'MM/dd/yyyy');
    return `${newDate} at`;
};

export const formatDate = (dateTimeStr: string) =>  {
    const dateStr = parseJSON(dateTimeStr);
    const newDate = format(new Date(dateStr), 'MM/dd/yyyy');
    return `${newDate}`;
};

export const formatTime = (dateTimeStr: string) =>  {
    const dateStr = parseJSON(dateTimeStr);
    const newTime = format(new Date(dateStr), 'hh:mm aaaa');
    return `${newTime}`;
};

